import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { FilterPreset } from '@ipfabric/utils';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { selectFilterPreset } from './selectFilterPreset';

export interface SelectFilterPresetByIdCommand {
  presetId: string | null;
}

export const selectFilterPresetById: ApiTableCommandFactory<
  SelectFilterPresetByIdCommand
> = (cmdContext, dispatch) => async (command) => {
  let preset: FilterPreset | null = null;
  if (command.presetId !== null) {
    preset =
      cmdContext
        .getTableModel()
        .filterPresets.find((preset) => preset.id === command.presetId) ?? null;
    if (preset === null) {
      stumble(`Tried to select preset by non-existing ID ${command.presetId}`);
      return;
    }
  }
  dispatch(selectFilterPreset, { preset });
};
